import { Injectable } from '@angular/core';

import {
  AuctionItemIdsDto,
  AuctionItemPayload,
  AuctionItemSell, InventoryManagementSearchResult,
  LegacyDisclosuresDto,
  LegacyYellowLight,
  UpdateYellowLightDisclosureDto,
  UpdateYellowLightDisclosureResponseDto,
  YellowLight
} from 'remarketing-angular-library';
import { UpdateResultSummary, VehicleUpdateSummary } from '../interfaces/update-vehicles-action.interface';



@Injectable({
  providedIn: 'root'
})
export class UpdateSelectedVehiclesService {

  buildYellowLightDisclosuresDto(vehiclesEligibleForUpdate: InventoryManagementSearchResult[],
    selectedYellowLights: YellowLight[]): UpdateYellowLightDisclosureDto {
    const disclosures = {
      yellowLights: this.buildLegacyYellowLights(selectedYellowLights)
    } as LegacyDisclosuresDto;

    return {
      itemIds: this.buildVehicleIdentifiers(vehiclesEligibleForUpdate),
      disclosures: disclosures
    } as UpdateYellowLightDisclosureDto;
  }

  buildProceedsReleasePayload(vehiclesEligibleForUpdate: InventoryManagementSearchResult[]){
    const auctionItems = this.buildVehicleIdentifiers(vehiclesEligibleForUpdate);
    return { itemIds: auctionItems } as AuctionItemPayload;
  }

  buildVehicleIdentifiers(vehiclesEligibleForUpdate: InventoryManagementSearchResult[]): AuctionItemIdsDto[] {
    const vehicleIdentifiers = [];
    if (vehiclesEligibleForUpdate?.length) {
      vehiclesEligibleForUpdate.forEach(vehicle => {
        vehicleIdentifiers.push(
          {
            vin: vehicle.itemDetail.vin,
            legacyAuctionItemId: vehicle.legacyAuctionItemId,
            auctionItemUuid: vehicle.auctionItemUuid
          } as AuctionItemIdsDto
        );
      });
      return vehicleIdentifiers;
    } else {
      return [];
    }
  }

  buildLegacyYellowLights(selectedYellowLights: YellowLight[]): LegacyYellowLight[] {
    const legacyYellowLights = [];
    if(selectedYellowLights?.length) {
      selectedYellowLights.forEach(yellowLight => {
        legacyYellowLights.push(
          {
            disclosureCode: yellowLight.disclosureCode,
            disclosureDescription: yellowLight.disclosureDescription,
            selected: yellowLight.selected
          } as LegacyYellowLight
        );
      });
      return legacyYellowLights;
    } else {
      return [];
    }
  }

  formatUpdateYellowLightDisclosureResponseDto(updateYellowLightResults: UpdateYellowLightDisclosureResponseDto[]): UpdateResultSummary {
    const successes = [];
    const failures = [];

    if(updateYellowLightResults?.length > 0) {
      updateYellowLightResults.forEach(result => {
        const vehicleSummary = {
          vin: result.vin,
          errors: result.success ? [] : result.errors
        } as VehicleUpdateSummary;

        result.success ? successes.push(vehicleSummary) : failures.push(vehicleSummary);
      });
    }

    return {
      successes: successes,
      failures: failures
    } as UpdateResultSummary;
  }

  formatUpdateVehicleStatusResponse(response: any, auctionItemGroupByUuid: any){
    const successes = [];
    const failures = [];

    if(response?.length > 0){
      response.forEach(result => {
        const vin = auctionItemGroupByUuid[result.auctionItemUuid][0].itemDetail.vin;

        const vehicleSummary = {
          vin: vin,
          errors: result.success ? [] : result.errors
        } as VehicleUpdateSummary;

        result.success ? successes.push(vehicleSummary) : failures.push(vehicleSummary);
      });
    }

    return {
      successes: successes,
      failures: failures
    } as UpdateResultSummary;
  }

  formatProceeds(response){
    const successes = [];
    const failures = [];

    if(response?.length > 0){
      response.forEach(result => {
        const vehicleSummary = {
          vin: result.vin,
          errors: result.success ? [] : result.errors
        } as VehicleUpdateSummary;

        result.success ? successes.push(vehicleSummary) : failures.push(vehicleSummary);
      });
    }

    return {
      successes: successes,
      failures: failures
    } as UpdateResultSummary;
  }
}
